var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 44,
    viewBox: "0 0 49 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 25.3332C28.6421 25.3332 32 21.6022 32 16.9998C32 12.3975 28.6421 8.6665 24.5 8.6665C20.3579 8.6665 17 12.3975 17 16.9998C17 21.6022 20.3579 25.3332 24.5 25.3332Z",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 42.0002C35 38.906 33.8938 35.9385 31.9246 33.7506C29.9555 31.5627 27.2848 30.3335 24.5 30.3335C21.7152 30.3335 19.0445 31.5627 17.0754 33.7506C15.1063 35.9385 14 38.906 14 42.0002H35Z",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 18.6667C37.7784 18.6667 39.0356 18.3036 40.1522 17.6118C41.2688 16.9201 42.2078 15.9228 42.8799 14.7144C43.552 13.5061 43.935 12.1269 43.9924 10.7079C44.0499 9.28887 43.7799 7.87706 43.2082 6.60656C42.6365 5.33605 41.7819 4.24901 40.7258 3.44867C39.6696 2.64832 38.4468 2.16124 37.1735 2.03367C35.9003 1.90611 34.6188 2.14229 33.4508 2.7198C32.2828 3.2973 31.267 4.19696 30.5 5.33334",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35.3332H47C47 32.239 45.8938 29.2715 43.9246 27.0836C41.9555 24.8957 39.2848 23.6665 36.5 23.6665",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.33334C17.7329 4.19696 16.7172 3.2973 15.5492 2.7198C14.3812 2.14229 13.0997 1.90611 11.8265 2.03367C10.5532 2.16124 9.33042 2.64832 8.27423 3.44867C7.21805 4.24901 6.36352 5.33605 5.79179 6.60656C5.22006 7.87706 4.95011 9.28887 5.00758 10.7079C5.06504 12.1269 5.44801 13.5061 6.12012 14.7144C6.79222 15.9228 7.73116 16.9201 8.84776 17.6118C9.96437 18.3036 11.2216 18.6667 12.5 18.6667",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.6665C9.71523 23.6665 7.04451 24.8957 5.07538 27.0836C3.10625 29.2715 2 32.239 2 35.3332H11",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTt);
export default __webpack_public_path__ + "static/media/tt.b845f66845178de55fb08688a9e34bda.svg";
export { ForwardRef as ReactComponent };